import { DOMAIN_TYPE } from '../constants';

const DOMAIN_NAME = 'toast';

export const ADD_TOAST = `${DOMAIN_TYPE}/${DOMAIN_NAME}/ADD_TOAST` as const;
export const DISMISS_TOAST =
  `${DOMAIN_TYPE}/${DOMAIN_NAME}/DISMISS_TOAST` as const;
